module.exports = __webpack_public_path__ + "static/media/7.dffc70c8.svg";